import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import routes from './routes';

Vue.use(Router);

const errorMap = {
  'distributors are not supported': 'Only dealers are supported, but distributors will be supported soon.',
  'token is invalid': 'Your credentials are expired or invalid.',
};

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const { meta: { requiresAuth } } = to;

  if (requiresAuth !== false && !store.state.session.token) {
    return next({ name: 'Login' });
  }

  if (store.getters.error && (to.params.error === true || !to.params.error)) {
    return next({ name: 'Login', params: { error: errorMap[store.getters.error] } });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js